import { Button } from "semantic-ui-react";

export const NewModalButtonTriggerComponent = (props: {
  props: NewModalButtonTriggerComponentProps;
  setOpen: any;
}) => {
  return (
    <Button onClick={() => props.setOpen(true)}>{props.props.label}</Button>
  );
};

export type NewModalButtonTriggerComponentProps = {
  label: string;
  type: "button";
};
